<template>
    <div>
        <el-form
            ref="formData"
            :model="formData"
            label-width="180px"
            size="mini"
        >
            <el-form-item label="选择日期:">
                <el-date-picker
                    size="mini"
                    style="width: 220px"
                    v-model="date"
                    type="daterange"
                    align="right"
                    unlink-panels
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="datechange"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div style="text-align:right;">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit">确认导出</el-button>
        </div>
    </div>
</template>

<script>
import { sp_ad_export_file } from "@/api/Product/Product";
import { binary_download } from "../../utils/method";
import { downloadFileUrl } from "@/utils/method";

export default {
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const that = this;
        return {
            date: "",
            formData: {
                start_date: "",
                end_date: ""
            },
            max_date: "",
            min_date: "",
            pickerOptions: {
                disabledDate(time) {
                    const lastDate = new Date(that.data.early_date).getTime();
                    const endDate = new Date(that.data.late_date).getTime();
                    return (
                        time.getTime() > endDate ||
                        time.getTime() < lastDate - 3600 * 24 * 1000
                    );
                }
            }
        };
    },
    mounted() {
        // this.formData.start_date = this.data.early_date;
        // this.formData.end_date = this.data.late_date;
        this.min_date = this.data.early_date;
        this.max_date = this.data.late_date;
    },
    methods: {
        //时间筛选
        datechange(tab) {
            if (tab) {
                this.formData.start_date = tab[0];
                this.formData.end_date = tab[1];
            } else {
                this.formData.start_date = "";
                this.formData.end_date = "";
            }
        },
        submit() {
            const loading = this.$loading({
                lock: true,
                text: "正在导出...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            sp_ad_export_file({
                ad_portfolio_name: this.data.ad_portfolio_name,
                shop_name: this.data.shop_name,
                state: this.data.state,
                ...this.formData
            }).then(res => {
                loading.close();
                if (res.code !== 0) {
                    return this.$message({
                        message: "导出失败",
                        type: "fail"
                    });
                }

                this.downFile(res.data)
                this.close();
                this.$message({
                    message: "导出成功",
                    type: "success"
                });
            });
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        close() {
            this.date = ''
            this.$emit("closeExport");
        }
    }
};
</script>
